import { ColDef } from 'ag-grid-community';
import { IndigoAppContextType } from 'app/AppContext';
import {
    toColDef,
    toNumericColDef,
    toCurrencyColDef,
    toPercentColDef,
} from '@instinet-analytics/semantic-ui-components';

export function liquiditySummaryColumnDefinitions(
    context: IndigoAppContextType
): ColDef[] {
    return [
        toColDef(context, 'label', {
            headerName: '',
            minWidth: 140,
            textAlign: 'left',
        }),
        toNumericColDef(context, 'shares', {
            headerName: 'Quantity',
            minWidth: 80,
        }),
        toCurrencyColDef(context, 'value', {
            headerName: 'Value',
            minWidth: 100,
        }),
        toPercentColDef(context, 'orderLeaves', {
            headerName: 'Order Leaves %',
            minWidth: 70,
            dps: 1,
        }),
        toPercentColDef(context, 'fullOrder', {
            headerName: 'Full Order %',
            minWidth: 70,
            dps: 1,
        }),
        toPercentColDef(context, 'propOfAdv', {
            headerName: 'Proportion of ADV',
            minWidth: 80,
        }),
        toPercentColDef(context, 'totalVsHist', {
            headerName: 'Today vs Hist',
            minWidth: 70,
            showSign: true,
        }),
    ];
}
